import { render, staticRenderFns } from "./plat.vue?vue&type=template&id=44dbd27d&scoped=true"
import script from "./plat.vue?vue&type=script&lang=js"
export * from "./plat.vue?vue&type=script&lang=js"
import style0 from "./plat.vue?vue&type=style&index=0&id=44dbd27d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dbd27d",
  null
  
)

export default component.exports